import { globalBreak } from "@/styles/break";
import { resBreak } from "@/utils/resBreak";
import { SxProps } from "@mui/material";

export const containerSX:SxProps = {
    flexDirection:'row',
    alignItems:'center',
    marginTop:'0 !important',
    flexWrap:'wrap',
    rowGap:resBreak<'row-gap'>({mobile:0.5, tablet:0, desktop:1}),
    columnGap:1, 
    display: globalBreak({mobile:'grid', desktop:'flex'}),
    gridTemplateColumns:'1fr',
    '& > div.rating_summary_container':{
        display: globalBreak({mobile:'flex', desktop:'flex'}),
        flexDirection: globalBreak({mobile:'column', desktop:'row'}),
        columnGap: globalBreak({mobile:'none', desktop:1}),
        rowGap:0.5,
        gridTemplateColumns:'7fr 1fr 7fr',
    },
    '& .rating_summary':{
        display:'flex',
        alignItems:'center',
        justifyContent:'space-between',
        '& .bv_main_container .bv_main_rating_button':{
            mr:'0 !important',
            pr:'0 !important'
        },
        '&:not(:has(.bv_main_rating_button)) + .rating-summary-divider': {
            display: 'none'
        },
        '&:not(:has(.bv_main_rating_button))': {
            display: 'none'
        },
        '& .bv_main_container .bv_rating_summary_buttons_container':{
            mr:'0 !important',
            pr:'0 !important'
        }

    },
    '& .rating-summary-divider': {
            display: globalBreak({mobile:'none', desktop:'block'})
       },
    '& >span':{
        fontSize:14
    },
    '& .brand-serie-link-container':{
        columnGap:1,
        flexDirection:'row',
        width:'100%'
    }

}